import { ViewpointGroupingRulesCommands } from './viewpointGroupingRulesCommands';
import { GroupsTab } from '@ardoq/perspectives';
import { GroupingRulesState } from './groupingRulesTypes';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { ModalBodyLayout } from '@ardoq/page-layout';
import type { I18nLocale } from '@ardoq/i18n';

type GroupingRulesContentProps = {
  closeViewpointBuilder: () => void;
  commands: ViewpointGroupingRulesCommands;
  state: GroupingRulesState;
  primaryButtonConfig: PrimaryButtonConfig;
  i18nLocale: I18nLocale;
};

export const GroupingRulesContent = ({
  state,
  commands,
  closeViewpointBuilder,
  primaryButtonConfig,
  i18nLocale,
}: GroupingRulesContentProps) => (
  <ModalBodyLayout
    footerContent={
      <ViewpointBuilderFooter
        closeViewpointBuilder={closeViewpointBuilder}
        primaryButtonConfig={primaryButtonConfig}
        i18nLocale={i18nLocale}
      />
    }
  >
    <GroupsTab {...{ ...state, ...commands, i18nLocale }} />
  </ModalBodyLayout>
);
